module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/light/star-exclamation.svg?4fe991ed1cf9fea7152a37039eb1f51b";